import { type EmptyObject } from '@ve/types/EmptyObject';

interface MirCashbackParams {
    mirCashback?: true;
}

const mirCashback_ = (params: Record<string, string>): MirCashbackParams | EmptyObject => {
  const { mirCashback } = params;

  if (!mirCashback) {
    return {};
  }

  return { mirCashback: true };
};
export default mirCashback_;
